<template>
  <div>
    <perfect-scrollbar>
      <table class="table table-striped table-bordered table-condensed table-responsive" :bordered="true">
        <thead>
        <tr>
          <th v-for="tableHeader in tableHeaders" :key="tableHeader.value">
            {{ tableHeader.text }}
          </th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(role, roleIndex) in taskType.allowedAccessRole" :key="role.clientType['@id']">
            <th>{{ role.clientType.title }}</th>
            <td v-for="(permission, index) in role.permissions" :key="permission[index]">
              <b-form-checkbox disabled v-model="taskType.allowedAccessRole[roleIndex].permissions[index].value"></b-form-checkbox>
            </td>
          </tr>
        </tbody>
      </table>
    </perfect-scrollbar>
  </div>
</template>

<script>
import ApiService from '@/utils/ApiService'

export default {
  name: 'ListRolesForTaskType',
  props: {
    taskType: {
      required: false
    }
  },
  data () {
    return {
      clientTypes: [],
      singlePermissions: [
        {
          value: false,
          text: 'create'
        },
        {
          value: false,
          text: 'read'
        },
        {
          value: false,
          text: 'read2'
        },
        {
          value: false,
          text: 'update'
        },
        {
          value: false,
          text: 'delete'
        },
        {
          value: false,
          text: 'accessFirm'
        },
        {
          value: false,
          text: 'accessGroup'
        },
        {
          value: false,
          text: 'accessSelf'
        },
        {
          value: false,
          text: 'accessAll'
        }
      ],
      tableHeaders: [
        {
          value: null,
          text: this.$t('views.excmtasktype.form.role')
        },
        {
          value: 'C',
          text: this.$t('views.excmtasktype.form.create')
        },
        {
          value: 'R1',
          text: this.$t('views.excmtasktype.form.read')
        },
        {
          value: 'R2',
          text: this.$t('views.excmtasktype.form.read2')
        },
        {
          value: 'U',
          text: this.$t('views.excmtasktype.form.update')
        },
        {
          value: 'D',
          text: this.$t('views.excmtasktype.form.delete')
        },
        {
          value: 'AF',
          text: this.$t('views.excmtasktype.form.accessFirm')
        },
        {
          value: 'AG',
          text: this.$t('views.excmtasktype.form.accessGroup')
        },
        {
          value: 'AS',
          text: this.$t('views.excmtasktype.form.accessSelf')
        },
        {
          value: 'AA',
          text: this.$t('views.excmtasktype.form.accessAll')
        }
      ]
    }
  },
  mounted () {
    this.getClientTypes()
  },
  methods: {
    getClientTypes () {
      let params = {
        pagination: false
      }
      const response = new ApiService('client_types', params).getResults()
      this.clientTypes = response.items
    }
  }
}
</script>

<style scoped>

</style>
